/* eslint-disable no-underscore-dangle */

import Renderer from './image-type-icon-renderer';

const _ = require('lodash');
const DefaultColumnComponent = require('@gluenetworks/steve_ui_widgets').GridGl
  .DefaultColumnComponent;

class ImageTypeIconColumnComponent extends DefaultColumnComponent {
  constructor(value) {
    super(value);
    this._value = value;
    this._renderer = new Renderer(this);
  }

  /** **************************************** */
  /* START PRIVATE COMPONENT MODEL METHODS   */
  /** **************************************** */

  _registerListeners() {}

  _unregisterListeners() {}

  /** **************************************** */
  /* END PRIVATE COMPONENT MODEL METHODS     */
  /* START PUBLIC COMPONENT MODEL METHODS    */
  /** **************************************** */

  get renderer() {
    return this.getRenderer();
  }

  getRenderer() {
    return this._renderer;
  }

  shutdown() {
    const prom = this._renderer._shutdown();
    this._renderer = undefined;
    this._value = undefined;
    return prom;
  }

  /** **************************************** */
  /* END COMPONENT MODEL METHODS             */
  /* START HANDLER METHODS                   */
  /** **************************************** */

  /** **************************************** */
  /* END HANDLER METHODS                     */
  /* START PRIVATE METHODS                   */
  /** **************************************** */

  /** **************************************** */
  /* END PRIVATE METHODS                     */
  /* START PUBLIC API METHODS                */
  /** **************************************** */

  setValue(newVal) {
    if (!_.isUndefined(newVal)) {
      this.setImageType(newVal);
    }
  }

  getValue() {
    return this.getImageType();
  }

  setImageType(newVal) {
    this._value = newVal;
    this.emit('ImageType', newVal);
    return this;
  }

  getImageType() {
    return this._value;
  }

  /** **************************************** */
  /* END PUBLIC API METHODS                  */
  /** **************************************** */
}

export default ImageTypeIconColumnComponent;
